import React from "react";
import { useSelector, useDispatch } from "react-redux";

import styled from "styled-components";
import { getLandscapeClass } from "../../lib/utils";
import { getActiveModule } from "../../store";
import { goToModule, openChat, sendModuleAnswer } from "../../actions";
import { addMessage } from "../messages/actions";
import { MessageTypes } from "../../lib/types";

/**
 * Render just a limited amount of gallery answers.
 * Used both in regular gallery and in 2 different floorplan components.
 */
export const GalleryAnswers = () => {
  const activeModule = useSelector(getActiveModule);
  const dispatch = useDispatch();

  /**
   * When user clicks on some option in the right gallery column.
   * Not doing the whole `BotMessage.onAnswerClick` routine here on purpose.
   * @param answer
   */
  const onGalleryAnswerClick = (answer) => {
    dispatch(openChat());
    dispatch(addMessage({ type: MessageTypes.USER_MESSAGE, text: answer.text }));
    dispatch(
      sendModuleAnswer(activeModule.id, {
        id: answer.id,
        text: answer.text,
      })
    );
    dispatch(goToModule(answer.action));
  };

  return (activeModule.answers || []).slice(0, 4).map((answer, i) => {
    return (
      <GalleryAnswer key={i} onClick={() => onGalleryAnswerClick(answer)} className={getLandscapeClass()}>
        {answer.text}
      </GalleryAnswer>
    );
  });
};

/**
 * Chat answers shown on the right side of the open gallery.
 */
export const GalleryAnswer = styled.div`
  position: relative;
  display: block;
  padding: 13px 12px;
  margin: 3px 0;
  background-color: ${(props) => props.theme.brandColor || "white"};
  font-size: ${(props) => props.fontSize || "17px"};
  text-align: center;
  border-radius: 6px;
  color: #fff;
  transition: all 0.2s ease-out;
  cursor: pointer;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0.2;
  }

  &:hover:after {
    background-color: #ddd;
  }

  &.landscape {
    box-shadow: 0 2px 6px #d8d8d8;
    background-color: white;
    color: #595d61;
    display: inline-block;
    width: auto;
    border-radius: 23.5px;
    font-size: 12px;
    margin: 0 4px;

    &.active {
      background: ${(props) => props.theme.brandColorDarker};
      color: white;
    }

    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
    }

    &.bright {
      background-color: ${(props) => props.theme.brandColor};
      color: white;
    }
  }
`;
